$(function() {
	var image = document.getElementById('test1');

	const cropper = new Cropper(image, {
			  aspectRatio: 1 / 7,
			  crop: function(event) {
			    $('#crop_x').val(event.detail.x);
			    $('#crop_y').val(event.detail.y);
			    $('#crop_w').val(event.detail.width);
			    $('#crop_h').val(event.detail.height);
			  }
			  
	});
  
});